import React, { useState } from 'react';
import { useStore, DiscountCode } from '../../context/StoreContext';
import { Plus, Tag, Edit2 } from 'lucide-react';
export function AdminDiscounts() {
  const {
    discounts,
    addDiscount,
    updateDiscount
  } = useStore();
  const [showForm, setShowForm] = useState(false);
  const [editingCode, setEditingCode] = useState<string | null>(null);
  const [formData, setFormData] = useState<Partial<DiscountCode>>({
    code: '',
    description: '',
    type: 'percentage',
    value: 10,
    active: true,
    minSubtotal: 0
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (editingCode) {
      updateDiscount(editingCode, formData);
    } else {
      addDiscount({
        ...formData,
        timesUsed: 0
      } as DiscountCode);
    }
    setShowForm(false);
    setEditingCode(null);
  };
  const openEdit = (discount: DiscountCode) => {
    setFormData(discount);
    setEditingCode(discount.code);
    setShowForm(true);
  };
  return <div className="space-y-6" data-id="element-527">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-528">
        <h1 className="text-2xl font-extrabold text-gray-900" data-id="element-529">Discounts</h1>
        <button onClick={() => {
        setFormData({
          code: '',
          description: '',
          type: 'percentage',
          value: 10,
          active: true,
          minSubtotal: 0
        });
        setEditingCode(null);
        setShowForm(true);
      }} className="flex items-center gap-2 px-4 py-2 bg-yarbo-dark text-white rounded-lg text-sm font-bold hover:bg-black transition-colors" data-id="element-530">
          <Plus className="w-4 h-4" data-id="element-531" /> Create Discount
        </button>
      </div>

      {showForm && <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm" data-id="element-532">
          <h2 className="text-lg font-bold text-gray-900 mb-4" data-id="element-533">
            {editingCode ? 'Edit Discount' : 'New Discount'}
          </h2>
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-534">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-535">
              <div data-id="element-536">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-537">
                  Code
                </label>
                <input type="text" required disabled={!!editingCode} value={formData.code} onChange={e => setFormData({
              ...formData,
              code: e.target.value.toUpperCase()
            })} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark uppercase disabled:bg-gray-100" data-id="element-538" />
              </div>
              <div data-id="element-539">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-540">
                  Description
                </label>
                <input type="text" required value={formData.description} onChange={e => setFormData({
              ...formData,
              description: e.target.value
            })} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark" data-id="element-541" />
              </div>
              <div data-id="element-542">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-543">
                  Type
                </label>
                <select value={formData.type} onChange={e => setFormData({
              ...formData,
              type: e.target.value as any
            })} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark" data-id="element-544">
                  <option value="percentage" data-id="element-545">Percentage</option>
                  <option value="fixed" data-id="element-546">Fixed Amount</option>
                </select>
              </div>
              <div data-id="element-547">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-548">
                  Value
                </label>
                <input type="number" required min="0" step="0.01" value={formData.value} onChange={e => setFormData({
              ...formData,
              value: parseFloat(e.target.value)
            })} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark" data-id="element-549" />
              </div>
              <div data-id="element-550">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-551">
                  Minimum Subtotal
                </label>
                <input type="number" min="0" value={formData.minSubtotal} onChange={e => setFormData({
              ...formData,
              minSubtotal: parseFloat(e.target.value)
            })} className="w-full border-gray-300 rounded-lg shadow-sm focus:border-yarbo-dark focus:ring-yarbo-dark" data-id="element-552" />
              </div>
              <div className="flex items-center mt-6" data-id="element-553">
                <input id="active" type="checkbox" checked={formData.active} onChange={e => setFormData({
              ...formData,
              active: e.target.checked
            })} className="h-4 w-4 text-yarbo-dark focus:ring-yarbo-dark border-gray-300 rounded" data-id="element-554" />
                <label htmlFor="active" className="ml-2 block text-sm text-gray-900" data-id="element-555">
                  Active
                </label>
              </div>
            </div>
            <div className="flex gap-3 pt-4" data-id="element-556">
              <button type="submit" className="bg-yarbo-dark text-white font-bold px-4 py-2 rounded-lg hover:bg-black" data-id="element-557">
                Save Discount
              </button>
              <button type="button" onClick={() => setShowForm(false)} className="bg-white border border-gray-300 text-gray-700 font-bold px-4 py-2 rounded-lg hover:bg-gray-50" data-id="element-558">
                Cancel
              </button>
            </div>
          </form>
        </div>}

      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-559">
        <div className="overflow-x-auto" data-id="element-560">
          <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-561">
            <thead className="bg-gray-50 text-gray-500 font-medium" data-id="element-562">
              <tr data-id="element-563">
                <th className="px-6 py-4" data-id="element-564">Code</th>
                <th className="px-6 py-4" data-id="element-565">Description</th>
                <th className="px-6 py-4" data-id="element-566">Value</th>
                <th className="px-6 py-4" data-id="element-567">Status</th>
                <th className="px-6 py-4" data-id="element-568">Times Used</th>
                <th className="px-6 py-4" data-id="element-569"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-570">
              {discounts.map(discount => <tr key={discount.code} className="hover:bg-gray-50" data-id="element-571">
                  <td className="px-6 py-4" data-id="element-572">
                    <div className="flex items-center gap-2 font-bold text-gray-900" data-id="element-573">
                      <Tag className="w-4 h-4 text-gray-400" data-id="element-574" /> {discount.code}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-gray-600" data-id="element-575">
                    {discount.description}
                  </td>
                  <td className="px-6 py-4 font-medium text-gray-900" data-id="element-576">
                    {discount.type === 'percentage' ? `${discount.value}%` : `$${discount.value}`}
                  </td>
                  <td className="px-6 py-4" data-id="element-577">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold ${discount.active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-578">
                      {discount.active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-600" data-id="element-579">
                    {discount.timesUsed}
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-580">
                    <button onClick={() => openEdit(discount)} className="text-yarbo-dark hover:text-black p-1" data-id="element-581">
                      <Edit2 className="w-4 h-4" data-id="element-582" />
                    </button>
                  </td>
                </tr>)}
              {discounts.length === 0 && <tr data-id="element-583">
                  <td colSpan={6} className="px-6 py-12 text-center text-gray-500" data-id="element-584">
                    No discounts found.
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}